import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getWebViewHtml } from '../../action/webViewContentAction.js';
import './ModalTip.css';

class ModalSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount(){
    // document.getElementsByTagName('body')[0].setAttribute("style","overflow:hidden")
  }
  componentWillUnmount(){
    // document.getElementsByTagName('body')[0].setAttribute("style","")
  }
  render(){
    let {riskModalData}=this.props;
    console.log(riskModalData)
    return (
      <div>
    {
      this.props.payLoading&&riskModalData?<div  className='containerModal_old' >
          <div className='modalView_old'>
            <div className='titleText_old'style = {{marginTop: this.props.titleBC ? 6 : 20}}>{riskModalData.title}
            </div>
            <div className='contentText_old' >{riskModalData.content}</div>
            <div className='contentTwoText_old' >{riskModalData.contentBC}</div>
            <div className='footView_old'>
              <p onClick={()=>riskModalData.onCancel()}>{riskModalData.leftButtonTitle}</p>
              <p onClick={()=>riskModalData.onOK()}>{riskModalData.rightButtonTitle}</p>
            </div>
          </div>
        </div>:null
    }
    </div>
        
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    riskModalData: state.riskModalData,
    payLoading:state.payLoading
  }
}
export default connect(mapStateToProps)(ModalSelect);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalSelect.js